import { FC, useCallback, useEffect, useRef } from "react";
import { Typography, useTheme } from "@mui/material";

import { ROUTES } from "constants/routes";

import useSignUp from "./hooks/useSignUp";

import { Button } from "components/common/Button";
import { Link } from "components/common/Link";
import { Stepper } from "components/common/Stepper";

import { StyledSignUp } from "styles/sign-up";

const SignUp: FC = () => {
  const theme = useTheme();

  const {
    loading,
    stepsCount,
    step,
    currentStepContent,
    validFieldErrors,
    handleSubmit,
    handleStepChange,
  } = useSignUp();

  const headerRef = useRef<HTMLDivElement>(null);

  const scrollToComponentWithError = useCallback(() => {
    if (
      validFieldErrors &&
      validFieldErrors.length > 0 &&
      headerRef &&
      headerRef.current
    ) {
      headerRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [validFieldErrors, headerRef]);

  useEffect(() => {
    scrollToComponentWithError();
  }, [scrollToComponentWithError]);

  const handleBtnClick = useCallback(() => {
    scrollToComponentWithError();
    handleSubmit?.();
  }, [handleSubmit, scrollToComponentWithError]);

  return (
    <StyledSignUp>
      <Stepper
        stepsCount={stepsCount}
        activeStep={step}
        className="sign-up__stepper"
        onStepClick={handleStepChange}
      />
      <div ref={headerRef}>{currentStepContent}</div>
      <Button
        className="sign-up__btn"
        onClick={handleBtnClick}
        disabled={loading}
        isLoading={loading}
      >
        {step === stepsCount ? "Sign up" : "Next step"}
      </Button>
      <Typography
        variant="bodyL"
        color={theme.palette.customGrey.dark}
        paragraph
        gap="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        Already have an account?
        <Link route={ROUTES.signIn} className="sign-in__forgot">
          Log in
        </Link>
      </Typography>
    </StyledSignUp>
  );
};

export default SignUp;
